/**
 * TryQuiPus — Application-wide numeric constants
 *
 * All magic numbers live here. Import from this file — never hardcode.
 */
import Decimal from 'decimal.js';

/** Max rows fetched in inbox queries (TransactionInbox, BankInbox). */
export const INBOX_QUERY_LIMIT = 2000;

/** Max rows fetched in transaction repository queries. */
export const TX_QUERY_LIMIT = 5000;

/** Max file size for document attachments (20 MB). */
export const MAX_ATTACHMENT_BYTES = 20 * 1024 * 1024;

/** Sentinel year used for stress-test / future period_balances snapshots. */
export const BALANCE_FUTURE_PERIOD = '2099';

/** Milliseconds before the undo toast auto-dismisses in BankInbox. */
export const UNDO_TIMEOUT_MS = 10_000;

/** IGV rate as a Decimal — always use Decimal, never native float. */
export const IGV_RATE = new Decimal('0.18');

/** IGV rate as plain integer percentage (for display only — never use in arithmetic). */
export const IGV_RATE_PCT = 18;

/** Human-readable IGV rate label. */
export const IGV_RATE_DISPLAY = '18%';

/** Divisor IGV = 1 + IGV_RATE. Used to extract base from total-with-IGV. */
export const IGV_DIVISOR = new Decimal('1.18');
